/**
 * Intercom is injected by smartsuite web,
 * here we are just tyring to ask Intercom to open particular article.
 * It doesn't work in:
 *  - automation-iui standalone mode
 *  - local env
 */

const ARTICLE_IMPORT = 4817036;

export const intercomOpenImportArticle = (): void =>
  intercomOpenArticleById(ARTICLE_IMPORT);

const withIntercom = (fn: (intercom: any) => void): void => {
  // @ts-expect-error
  if (window.Intercom) {
    // @ts-expect-error
    fn(window.Intercom);
  } else {
    console.warn("Intercom is disabled in this environment");
  }
};

// export const intercomOpenIntercom = (): void => {
//   withIntercom((intercom) => {
//     intercom("show");
//   });
// };

const intercomOpenArticleById = (id: number): void => {
  withIntercom((intercom) => {
    intercom("showArticle", id);
  });
};
